enum ExpenseType {
    SERVER_PAYMENT = 'server_payment',
    ENERGY_PAYMENT = 'energy_payment',
    TRX_EXCHANGE = 'trx_exchange',
    OTHER = 'other'
}

export default ExpenseType;
